import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { ApiError } from '../../services/api';
import { RootState } from '../rootReducer';
import { IHubspotAccount } from './account';
import {
  fetchHubspotAccounts,
  fetchHubspotAccountById
} from './hubspotAccounts.thunks';

export interface HubspotAccountsState {
  accounts: IHubspotAccount[];
  account: IHubspotAccount | null;
  loading: boolean;
  error: ApiError | null;
}

const initialState: HubspotAccountsState = {
  error: null,
  loading: false,
  accounts: [],
  account: null
};

const getHubspotAccountsState = (state: RootState): HubspotAccountsState => state.accounts.hubspotAccounts;
const getError = (state: RootState): ApiError | null => getHubspotAccountsState(state).error;
const getList = (state: RootState): IHubspotAccount[] => getHubspotAccountsState(state).accounts;
const getHubspotAccount = (state: RootState): IHubspotAccount | null => getHubspotAccountsState(state).account;
const getLoading = (state: RootState): boolean => getHubspotAccountsState(state).loading;

export const selectors = {
  getError,
  getList,
  getHubspotAccount,
  getLoading
};

const extraReducers = {
  [fetchHubspotAccounts.pending.type]: (state: HubspotAccountsState): void => {
    state.loading = true;
    state.accounts = [];
  },
  [fetchHubspotAccounts.fulfilled.type]: (state: HubspotAccountsState, action: AnyAction): void => {
    state.loading = false;
    state.accounts = action.payload.accounts || [];
  },
  [fetchHubspotAccounts.rejected.type]: (state: HubspotAccountsState, action: AnyAction): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [fetchHubspotAccountById.pending.type]: (state: HubspotAccountsState): void => {
    state.loading = true;
    state.account = null;
  },
  [fetchHubspotAccountById.fulfilled.type]: (state: HubspotAccountsState, action: AnyAction): void => {
    state.loading = false;
    state.account = action.payload || null;
  },
  [fetchHubspotAccountById.rejected.type]: (state: HubspotAccountsState, action: AnyAction): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const hubspotAccountsSlice = createSlice({
  name: 'hubspotAccounts',
  initialState,
  reducers: {
    resetHubspotAccount: (state: HubspotAccountsState) => {
      state.account = null;
    }
  },
  extraReducers
});

export default hubspotAccountsSlice.reducer;
export const actions = {
  ...hubspotAccountsSlice.actions,
  fetchHubspotAccounts
};
